require('/ui/components/card/card.module.scss.module.css');

export const card = "_card_gpqzl_1";
export const cardFullWidth = "_card-full-width_gpqzl_1";
export const taskFlowStyle = "_task-flow-style_gpqzl_1";
export const disabledStyle = "_disabled-style_gpqzl_1";
export const buttonCardWrapper = "_button-card-wrapper_gpqzl_1";
export const cardChildrenContainer = "_card-children-container_gpqzl_1";
export const nestedInteractiveElStyle = "_nested-interactive-el-style_gpqzl_1";
export const cardHeader = "_card-header_gpqzl_1";
export const cardHeaderHasActions = "_card-header-has-actions_gpqzl_1";
export const cardHeaderIconContainerParent = "_card-header-icon-container-parent_gpqzl_1";
export const cardHeaderIconContainer = "_card-header-icon-container_gpqzl_1";
export const cardHeaderTitleHasMetadata = "_card-header-title-has-metadata_gpqzl_1";
export const cardHeaderActions = "_card-header-actions_gpqzl_1";
export const cardBody = "_card-body_gpqzl_1";
export const cardHeaderHasIcon = "_card-header-has-icon_gpqzl_1";
export const actionableCard = "_actionable-card_gpqzl_1";
export const selected = "_selected_gpqzl_1";
